import { gql } from '@apollo/client';

export const CARD_QUERIES = {
  GetAgreements: 'GetAgreements',
  GetAgreement: 'GetAgreement',
  GuiaUsoTarjetaDebitoDale: 'GuiaUsoTarjetaDebitoDale',
  BasicCardInformation: 'BasicCardInformation',
  GetSensitiveInformation: 'GetSensitiveInformation',
  GetReasonsCancellation: 'GetReasonsCancellation',
  GetValidationCard: 'GetValidationCard',
  GET_TyC_NFC: 'GET_TyC_NFC',
};

export const GET_AGREEMENTS = gql`
  query GetAgreements {
    getAgreements {
      data {
        id
        image
        imageCarousel
        title
        description
        productId
        agreementCardProductId
        agreementId
        cardTypes
        charge
        url_benefits
        benefits {
          description
          icon
          title
        }
      }
    }
  }
`;

export const GET_AGREEMENT_BY_ID = gql`
  query GetAgreement($agreementId: Float!) {
    getAgreement(agreementId: $agreementId) {
      data {
        benefits {
          title
          description
          icon
        }
        url_benefits
      }
    }
  }
`;

export const GET_USER_GUIDE = gql`
  query GuiaUsoTarjetaDebitoDale {
    GuiaUsoTarjetaDebitoDale: getLegaldocuments(
      type: "GUTDD"
      person: "TV"
      action: "TARJETA"
    ) {
      version
      title
      text
    }
  }
`;

export const GET_BASIC_CARD_INFORMATION = gql`
  query BasicCardInformation {
    basicCardInformation {
      data {
        cardId
        cardNumber
        cardType
        plasticName
        statusId
        cardImage
        productId
        agreementId
        address
        cityName
      }
    }
  }
`;

export const GET_SENSITIVE_INFORMATION = gql`
  query GetSensitiveInformation($body: CardSensitiveRequest!) {
    getSensitiveInformationVirtualCard(body: $body) {
      data {
        encrypt
        cardImage
      }
    }
  }
`;

export const GET_REASONS_CANCELLATION = gql`
  query GetReasonsCancellation($cardId: Float!) {
    getReasonsCancellation(cardId: $cardId) {
      data {
        reason
        reasonCRM
        statusCRM
      }
    }
  }
`;

export const GET_VALIDATION_CARD = gql`
  query GetValidationCard {
    getValidationCard {
      data {
        validationCard
        statusId
        cardId
      }
    }
  }
`;

export const GET_TyC_NFC = gql`
  query TyCNFC {
    TyCNFC: getLegaldocuments(type: "NFC", person: "TC", action: "NFC") {
      version
      title
      text
    }
  }
`;

export const GET_AGREEMENT_BY_PROVIDER_ID = gql`
  query getAgreementByProviderIdCode($body: AgreementByProviderIdCodeRequest!){
    getAgreementByProviderIdCode(body: $body) {
        ATTRIBUTES
    }
  }
`;